import { http } from './config'

export default {
    getAllList: (params) => {
        return http.get(`logs/listar?${params}`);
    },
    salvar: (log) => {
        return http.post('temp-logs', log, {
            headers: {
                'Test-Token': 'TEST-LOG-TOKEN'
            }
        });
    }
}
